function getButtonElement(button) {
	if (button?.jquery) {
		return button[0] || null;
	}

	return button || null;
}

function getIconSize(icon) {
	if (!icon) {
		return { width: 18, height: 17 };
	}

	const bounds = icon.getBoundingClientRect();
	const styles = window.getComputedStyle(icon);
	const width = bounds.width || parseFloat(styles.width) || 18;
	const height = bounds.height || parseFloat(styles.height) || 17;

	return { width, height };
}

export function isFavoriteButtonLoading(button) {
	const buttonElement = getButtonElement(button);
	return buttonElement?.dataset?.favoriteLoading === 'true';
}

export function startFavoriteButtonLoading(button, action = 'add') {
	const buttonElement = getButtonElement(button);
	if (!buttonElement || isFavoriteButtonLoading(buttonElement)) {
		return () => {};
	}

	const icon = buttonElement.querySelector('img, svg');
	const { width, height } = getIconSize(icon);
	const spinner = document.createElement('span');
	const normalizedAction = action === 'remove' ? 'remove' : 'add';
	const previousDisabled = Boolean(buttonElement.disabled);
	const previousAriaBusy = buttonElement.getAttribute('aria-busy');
	const previousAriaLabel = buttonElement.getAttribute('aria-label');
	const previousIconAriaHidden = icon?.getAttribute('aria-hidden');
	const loadingAriaLabel =
		normalizedAction === 'remove'
			? 'Removendo cidade dos favoritos'
			: 'Adicionando cidade aos favoritos';

	spinner.className = `favorite-button-spinner favorite-button-spinner--${normalizedAction}`;
	spinner.setAttribute('aria-hidden', 'true');
	spinner.style.setProperty('--favorite-spinner-width', `${width}px`);
	spinner.style.setProperty('--favorite-spinner-height', `${height}px`);

	buttonElement.dataset.favoriteLoading = 'true';
	buttonElement.classList.add('favorite-button-loading');
	buttonElement.setAttribute('aria-busy', 'true');
	buttonElement.setAttribute('aria-label', loadingAriaLabel);
	buttonElement.disabled = true;

	if (icon) {
		icon.classList.add('favorite-button-loading__icon');
		icon.setAttribute('aria-hidden', 'true');
		icon.insertAdjacentElement('afterend', spinner);
	} else {
		buttonElement.appendChild(spinner);
	}

	return () => {
		spinner.remove();
		buttonElement.classList.remove('favorite-button-loading');
		delete buttonElement.dataset.favoriteLoading;
		buttonElement.disabled = previousDisabled;

		if (previousAriaBusy === null) {
			buttonElement.removeAttribute('aria-busy');
		} else {
			buttonElement.setAttribute('aria-busy', previousAriaBusy);
		}

		if (buttonElement.getAttribute('aria-label') === loadingAriaLabel) {
			if (previousAriaLabel === null) {
				buttonElement.removeAttribute('aria-label');
			} else {
				buttonElement.setAttribute('aria-label', previousAriaLabel);
			}
		}

		if (icon) {
			icon.classList.remove('favorite-button-loading__icon');
			if (previousIconAriaHidden === null) {
				icon.removeAttribute('aria-hidden');
			} else {
				icon.setAttribute('aria-hidden', previousIconAriaHidden);
			}
		}
	};
}
